export default __webpack_public_path__ + "static/media/icon-angle-down.bb71fc20.svg";